import { Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import CreditCustomerList from "../common/CreditCustomerList";
import Modal from "../common/CommonModal";
import dayjs from "dayjs";
import LeftTable from "./LeftTable";
import RightTable from "./RightTable";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const BillAllocation = () => {
  const crInputRef = useRef();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountDesc, setSelectedAccountDesc] = useState("");
  const [crPCModalOpen, setCrPCModalOpen] = useState(false);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [tableLeftList, setTableLeftList] = useState([]);
  const [tableRightList, setTableRightList] = useState([]);
  const [selectedAmountLeft, setSelectedAmountLeft] = useState(0);
  const [selectedAmountRight, setSelectedAmountRight] = useState(0);
  const [selectedRefNoRight, setSelectedRefNoRight] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });

  const [saving, setSaving] = useState(false);
  const [leftTableRows, setLeftTableRows] = useState([]);

  useEffect(() => {
    crInputRef.current?.focus();
    fetchAccountList("ALL");
  }, []);

  const fetchAccountList = async (valueToAPI) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data || []);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerSelect = (data) => {
    console.log("data:", data);
    setSelectedAccount(data.ACCOUNT);
    setSelectedAccountDesc(data.DESCRIPTION);
    setCrPCModalOpen(false);
    fetchTableLeftList(data.ACCOUNT);
    fetchTableRightList(data.ACCOUNT);
  };
  const fetchTableLeftList = async (acc) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMDocTransfer/${companyCode}/ONACC_LEFT/-/-/${acc}/-/-/-`;
    // let apiUrl = `https://cubixweberp.com:213/api/CRMDocTransfer/SUNRISEWEB/ONACC_LEFT/-/-/12050006/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setTableLeftList(response.data || []);
    } catch (err) {
      console.error("Error while fetching Table Left List", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchTableRightList = async (acc) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMDocTransfer/${companyCode}/ONACC_RIGHT/-/-/${acc}/-/-/-`;
    // let apiUrl = `https://cubixweberp.com:213/api/CRMDocTransfer/SUNRISEWEB/ONACC_RIGHT/-/-/12050006/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setTableRightList(response.data || []);
    } catch (err) {
      console.error("Error while fetching Table Right List", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectedRowsChange = (rows) => {
    console.log("Selected rows in parent bill allocation:", rows);
    setLeftTableRows(rows);
  };

  // const refNo = tableRightList[0]?.INV;

  const saveBillAllocation = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMOnAccAdj`;

    if (saving) return;

    if (!leftTableRows?.length) {
      setSnackbar({
        open: true,
        message: "Please select at least one bill",
        severity: "warning",
      });
      return;
    }

    try {
      setSaving(true);

      const payload = leftTableRows.map((row) => ({
        cmpcode: companyCode,
        mode: "ENTRY",
        AMOUNT: row?.AMOUNT,
        BALAMOUNT: row?.SETTLED_AMOUNT,
        // REFNO: refNo,
        REFNO: selectedRefNoRight,
        it_slno: row?.TR_SLNO,
      }));

      const response = await axios.post(apiURL, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Saved:", response.data);

      setSnackbar({
        open: true,
        message: "Bill allocation saved successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Save failed:", error);

      setSnackbar({
        open: true,
        message: "Failed to save bill allocation",
        severity: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800 mt-4">On-Account Adjustment</h2>
      {/* <h2 className="text-xl text-gray-800 mt-4">Bill Allocation</h2> */}

      <div className="flex justify-between items-center mb-4 gap-2 w-[70%] ">
        <div className="flex-1 ">
          <label className="block text-sm font-medium my-2">Account</label>
          <div className="flex gap-2 items-center justify-center ">
            <Tooltip title={selectedAccount.length > 0 ? "" : "Press F2"} arrow>
              <div className="w-32">
                <input
                  ref={crInputRef}
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      fetchAccountList("ALL");
                      setCrPCModalOpen(true);
                    }
                  }}
                  // type="text"
                  value={selectedAccount}
                  readOnly
                  placeholder="Press F2"
                  className={`w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white text-left `}
                />
              </div>
            </Tooltip>

            <div className="flex-1 w-full">
              <div className="flex items-center justify-between w-full px-3 py-2 border border-gray-300 rounded bg-white">
                <span className="text-sm truncate">
                  {selectedAccountDesc || "-"}
                </span>
              </div>
            </div>
            <div className="border border-gray-300 rounded px-3 py-2 space-y-2 text-md bg-white ">
              {/* Apply Filter Row */}
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-700 mr-4 ">
                  Unsettled:
                </span>
                <div className="flex gap-3">
                  {/* <span className="text-green-500 font-semibold">0</span> */}
                  <span className="text-red-500 font-semibold">
                    {selectedAmountLeft}
                  </span>
                </div>
              </div>

              {/* Ref Amount Row */}
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-700 mr-4">
                  Ref Amount:
                </span>
                <div className="flex gap-3">
                  {/* <span className="text-green-500 font-semibold">0</span> */}
                  <span className="text-red-500 font-semibold">
                    {selectedAmountRight}
                  </span>
                </div>
              </div>
            </div>

            {/* <div className="flex items-center justify-center gap-4">
              <label className="text-xs font-medium ml-4 my-2">
                Apply Filter
              </label>
              <div className="flex items-center gap-2 ">
                <label className="relative inline-block w-[3.5em] h-[2em]">
                  <input
                    type="checkbox"
                    className="peer sr-only"
                    checked={isApplyFilter}
                    onChange={(e) => setIsApplyFilter(e.target.checked)}
                  />
                  <span
                    className="
          absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
          after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
          after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
          after:transition-all after:duration-300 after:ease-in-out
          after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
          peer-checked:bg-blue-500
          peer-checked:after:translate-x-[1.5em]
          peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
          peer-active:after:w-[3em]
          peer-checked:peer-active:after:translate-x-[0.5em]
        "
                  ></span>
                </label>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="flex flex-col ">
        <div className="">
          <RightTable
            tableRightList={tableRightList}
            loading={loading}
            onAmountChange={setSelectedAmountRight}
            onRefNoChange={setSelectedRefNoRight}
          />
        </div>
        <div className="">
          <LeftTable
            tableLeftList={tableLeftList}
            loading={loading}
            onAmountChange={setSelectedAmountLeft}
            limitAmount={selectedAmountRight}
            onSelectedRowsChange={handleSelectedRowsChange}
          />
        </div>
      </div>

      {crPCModalOpen && (
        <Modal
          isOpen={crPCModalOpen}
          onClose={() => setCrPCModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
      )}
      <div className="flex  justify-center my-4">
        {tableLeftList?.length > 0 ? (
          <button
            onClick={saveBillAllocation}
            disabled={saving}
            className={`px-4 py-2  rounded text-white ${
              saving
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-black hover:bg-gray-800"
            }`}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        ) : (
          ""
        )}
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BillAllocation;
